<template>
    <div v-if="!this.activeSubscription().gracePeriodEnded">
        <v-row style="margin-top: -42px">
            <v-col cols="12" class="v-application">
                <v-btn id="create-project" color="primary" disabled class="ml-auto block" v-if="this.activeSubscription().state !== 'active' && this.activeSubscription().state !== 'trialing'">{{ $t('component_projectList_newProject') }}</v-btn>
                <v-btn id="create-project" color="primary" class="ml-auto block" :class="[!hasProject ? 'no-project':'']" @click.stop="openCreateProject" v-else>{{ $t('component_projectList_newProject') }}</v-btn>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    outlined
                    dense
                    hide-details
                    :label="$t('component_projectList_searchPlaceholder')"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="$t('component_projectList_searchPlaceholder')"
                    v-model="searchValue"
                    style="min-height: 36px"
                />
            </v-col>

            <v-col cols="6" class="text-right v-application">
                <v-btn-toggle v-model="viewModeSelected" dense>
                    <v-btn>
                        <v-icon :color="viewModeSelected === 0 ? 'primary' : ''">mdi-view-module-outline</v-icon>
                    </v-btn>
                    <v-btn >
                        <v-icon :color="viewModeSelected === 1 ? 'primary' : ''">mdi-format-list-bulleted</v-icon>
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <div  v-if="hasProject">
            <v-row v-if="viewModeSelected === 0">
                <v-col v-for="(item, index) in projectList.data" :key="index" :xl="4" :lg="4" :md="6" :sm="6" :cols="12" class="cardContainer projectCard" :class="displayCard(item.name)" :data-project-id="item.id">
                    <v-card rounded="lg" elevation="20">
                        <v-card-text class="px-0 py-0">
                            <div style="padding: 2rem 1.5rem 0 1.5rem">
                                <h2 class="cardKpiValue" style="">
                                    {{ item.name }}
                                </h2>
                                <div style="height: 22px">
                                    <p v-if="item.name !== item.url" style="font-style: italic">{{item.url}}</p>
                                </div>
                                <div id="project-action-buttons-container">
                                    <v-menu
                                        bottom
                                        left
                                        content-class="project-action-content-menu"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list id="project-action-menu" class="v-application">
                                            <v-list-item class="rename-project" @click.native="showEditProjectName(item.id)">
                                                <v-list-item-content>
                                                    <p>
                                                        <v-btn icon color="primary">
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                        <span>{{ $t('component_projectList_actionMenu_rename') }}</span>
                                                    </p>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item class="clone-project" @click.native="cloneProject(item.id)">
                                                <v-list-item-content>
                                                    <p>
                                                        <v-btn icon color="primary">
                                                            <v-icon>mdi-content-copy</v-icon>
                                                        </v-btn>
                                                        <span>{{ $t('component_projectList_actionMenu_clone') }}</span>
                                                    </p>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item class="delete-project" @click.native="displayConfirmDeleteProject(item.id)">
                                                <v-list-item-content>
                                                    <p>
                                                        <v-btn icon color="error">
                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                        </v-btn>
                                                        <span>{{ $t('component_projectList_actionMenu_delete') }}</span>
                                                    </p>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </div>

                            <img class="project-thumbnail" :style="{minHeight:`${thumbnailHeight}px`}" :src="item.thumbnail" :alt="`Thumbnail ${item.url}`" v-if="item.thumbnail">
                            <img class="project-thumbnail" :style="{minHeight:`${thumbnailHeight}px`}"  :alt="`Thumbnail ${item.url}`" v-else src="data:image/png;base64,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">

                            <div class="v-application py-4 px-4">
                                <v-btn outlined :href="`projects/${item.id}/${getDashboardName}`" color="primary" style="width: 100%">
                                    {{ $t('component_projectList_action_open') }}<v-icon right>mdi-chevron-double-right</v-icon>
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <div v-else>
                <v-card class="mt-4" style="height:  calc(100vh - 295px);">
                    <v-card-text>
                        <div class="tableContainer">
                            <ag-grid-table
                                :show-floating-filter="false"
                                :withTableMenu="false"
                                :ag-grid-options="{ rowHeight: 40 }"
                                agGridStyle="height: calc(100vh - 330px);"
                                :table-data="{columnDefs:columnDefs,rowData:tableListViewData}"
                                :showPagination="false"
                                @editProjectName="showEditProjectName"
                                @cloneProject="cloneProject"
                                @deleteProject="displayConfirmDeleteProject"
                            >
                            </ag-grid-table>
                        </div>
                    </v-card-text>
                </v-card>

            </div>
        </div>



        <confirm-dialog :title="$t('component_projectList_confirmDeleteTitle')" ref="confirmDeleteProject" @confirm-dialog-valid="confirmDeleteProject()">
            <div v-html="$t('component_projectList_confirmDeleteText')"></div>
        </confirm-dialog>

        <vs-popup :title="$t('component_projectList_titleEditProjectName')" :active.sync="editProjectNamePopup">
            <v-row>
                <v-col cols="9">
                    <v-text-field
                        v-model="renameProjectName"
                        placeholder="my-website.com"
                        dense
                        outlined
                        v-on:keyup.enter="saveProjectName()"
                    ></v-text-field>
                </v-col>
                <v-col cols="3" class="v-application">
                    <v-btn @click="saveProjectName()" color="primary">
                        {{$t('component_projectList_validEditProjectName')}}
                    </v-btn>
                </v-col>
            </v-row>
        </vs-popup>

        <v-dialog
            v-model="createProjectPopin"
            attach="#create-project-popin"
        >
                <project-creation-form v-if="createProjectPopin"  @close="createProjectPopin=false"/>
        </v-dialog>
        <div id="create-project-popin"></div>

    </div>

    <div v-else>

    </div>

</template>


<script>

import KpiValueEvolution from "@/components/yooda-components/KpiValueEvolution";
import apiCalls from '@/api/axios/configuration/project.js'
import Vue from 'vue'
import {mapGetters} from "vuex";
import projectApiCalls from "@/api/axios/configuration/project";
import ProjectCreationForm from "@/components/yooda-components/projectForm/ProjectCreationForm.vue";
import AgGridTable from "@/components/yooda-components/ag-grid-table/AgGridTable.vue";
import cellSort from "@/components/yooda-components/ag-grid-table/cell-sort/cellSort";

export default {
    props:{
        hasProject:true
    },

    data() {
        return {
            searchValue:'',
            renameProjectName:'',
            projectList:null,
            renameProjectId:null,
            deleteProjectId:null,
            createProjectPopin: false,
            editProjectNamePopup:false,
            thumbnailLoaded:false,
            viewModeSelected:0,
            columnDefs:[
                {headerName: this.$t('component_projectList_tableHeader_projectName'), field: 'name',cellRendererFramework: 'CellRendererLink',filter: false, comparator: cellSort.agGridTableSortCellValue},
                {headerName: '', sort:false,field: 'id', width: 20,cellRendererFramework: 'CellRendererProjectListAction', cellClass:'ag-grid-cell-right', headerClass:'ag-grid-header-right'},
            ]
        }
    },
    components: {
        AgGridTable,
        KpiValueEvolution,
        ProjectCreationForm,
    },
    computed:{
        ...mapGetters({
            activeSubscription:"customersManager/getActiveSubscription",
            maxProjectCount:"customersManager/getMaxProjectCount",
            additionalProjectCount:"customersManager/getAdditionalProjectCount",

        }),

        activeCustomerSubscription: {
            cache: false,
            get() {
                return this.$store.getters['customersManager/getActiveCustomerSubscription']()
            }
        },
        projectUsage(){

            let percent = 0
            let used = (this.projectsSummary.data ? this.projectsSummary.data.length : 0)
            if(this.maxProjectCount() > 0){percent = (used * 100) / (this.maxProjectCount()+this.additionalProjectCount())}
            return {used:used,total:this.maxProjectCount()+this.additionalProjectCount(),percent:percent}
        },

        tableListViewData(){
            if(!this.projectList.data){
                return []
            }

            let filteredProjectList = []

            this.projectList.data.forEach((data)=>{
                let displayable = false
                if (this.searchValue === '') {
                    displayable = true
                } else {
                    if (data.url.toLowerCase().includes((this.searchValue? this.searchValue.toLowerCase() : '')) || data.name.toLowerCase().includes((this.searchValue? this.searchValue.toLowerCase() : '')) ) {
                        displayable = true
                    }
                }

                if(displayable){
                    filteredProjectList.push({
                        name: {
                            href: `projects/${data.id}/${this.getDashboardName}`,
                            value: data.url === data.name ? data.url : `${data.name} (${data.url})`,
                            withIcon:true,
                            targetBlank: false
                        },

                        id:data.id
                    })
                }
            })

            return filteredProjectList
        },
        thumbnailHeight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 120
                case 'sm': return 150
                case 'md': return 180
                case 'lg': return 205
                case 'xl': return 210
                default : return 210
            }
        },
        getDashboardName(){
            if(!localStorage.getItem('defaultDashboardName')){
                return 'dashboard-recommendations'
            }
            else{
                if(localStorage.getItem('defaultDashboardName') === 'dashboard_recommendations'){
                    return 'dashboard-recommendations'
                }
                return 'dashboard'
            }

        }
    },
    watch:{
        viewModeSelected(){
            localStorage.setItem('projectListModeView', this.viewModeSelected)
            if(!this.thumbnailLoaded && this.viewModeSelected === 0){
                this.getComponentData({
                    componentName:'projectList',
                    promise: apiCalls.getProjects(this.$route.params.subscriptionId, true)
                })
                this.thumbnailLoaded = true
            }

        },
    },
    methods:{
        displayCard(name){
            let className = 'show'
            if(this.searchValue != ''){
                if(name.toLowerCase().search(this.searchValue.toLowerCase()) <0){
                    className = 'hide'
                }
            }
            return className
        },
        openCreateProject(){
            this.createProjectPopin = this.checkCreationProjectQuota()
        },
        displayConfirmDeleteProject(projectId){
            this.deleteProjectId = projectId
            this.$refs.confirmDeleteProject.displayDialog()
        },
        confirmDeleteProject(){
            let promise = apiCalls.deleteProject(this.deleteProjectId)
            promise.then((response) => {
                if(response){

                    this.getComponentData({
                        componentName:'projectList',
                        promise: apiCalls.getProjects(this.$route.params.subscriptionId, (this.viewModeSelected === 0))
                    })
                    this.thumbnailLoaded = this.viewModeSelected === 0

                    this.setDataComponent({
                        stateName:'projectsSummary',
                        promise: apiCalls.getProjectsSummary(this.$route.params.subscriptionId),
                    })

                    this.analyticsIdentify()
                    this.deleteProjectId = null
                }
            }).catch((error)   => {
                Vue.$log.error('deleteProject', error)
            })

        },
        showEditProjectName(item){
            let project = this.projectList.data.filter(data=>{
                return data.id === item
            })
            if(project.length){
                this.renameProjectId = item
                this.renameProjectName = project[0].name
                this.editProjectNamePopup = true
            }
        },

        checkCreationProjectQuota(){
            if(this.projectUsage.used >= this.projectUsage.total){
                this.$vs.notify({
                    time:8000,
                    title:this.$t('component_projectList_quota_project_title'),
                    text:this.$t('component_projectList_quota_project_text'),
                    color:'danger'
                })
                return false
            }
            else{
                return true
            }
        },

        cloneProject(item){
            if(this.checkCreationProjectQuota()){
                this.setDataComponent({
                    stateName:'projectInfo',
                    promise: apiCalls.getProjectInfo(item),
                    dataFormatter: this.projectData
                }).then(result =>{
                    if(result){
                        localStorage.removeItem('createProjectTmp')
                        localStorage.setItem('createProjectTmp',JSON.stringify({
                            websiteUrl: this.project.data.url,
                            competitors: this.project.data.rivals.map(data=>{ return data.url }),
                            locations: this.project.data.searchGeolocations,
                            keywords:this.project.data.keywords.map(data=>{ return data.string })
                        }))
                        this.createProjectPopin = true
                    }
                })
            }
        },
        saveProjectName(){
            this.$vs.loading()
            /* eslint-disable */
            const regex = /\?|!|_|`|\^|\[|\]|"|\(|\)|\||\{|\}|,|;|¤|\<|\>|\t|\r|\n/gi;
            /* eslint-enable */

            let promise = projectApiCalls.updateProject(this.renameProjectId,{name:this.renameProjectName.replace(regex, '')})
            promise.then((response)=>{
                if(response){
                    this.editProjectNamePopup = false

                    this.getComponentData({
                        componentName:'projectList',
                        promise: apiCalls.getProjects(this.$route.params.subscriptionId, (this.viewModeSelected === 0))
                    }).then(()=>{

                        this.thumbnailLoaded = this.viewModeSelected === 0
                        this.$vs.loading.close()
                    })


                }
            }).catch((error)=>{
                Vue.error('rename project',error)
                this.$vs.loading.close()
            })
        },
    },
    created() {
        if(this.$route.query.restoreProject){
            this.createProjectPopin = true
        }
    },
    beforeMount() {

        if(!localStorage.getItem('projectListModeView')){
            localStorage.setItem('projectListModeView','0')
        }
        this.viewModeSelected = parseInt(localStorage.getItem('projectListModeView'))

        this.getComponentData({
            componentName:'projectList',
            promise: apiCalls.getProjects(this.$route.params.subscriptionId, (this.viewModeSelected === 0))
        })

        this.thumbnailLoaded = this.viewModeSelected === 0



    }
}
</script>

<style lang="scss">

.projectCard{
    &.hide{
        display: none;
    }

    .cardKpiValue{
        font-size: 28px !important;
        font-weight: 400 !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;

    }

    #project-action-buttons-container{
        position: absolute;
        top: 10px;
        right:10px;
        span{
            opacity: 0.8;
            cursor: pointer;
            margin: 0 4px;
            &:hover{
                opacity: 1;
            }
        }
    }
    .projectEvolution{
        h2{ margin-bottom: 10px !important; }
    }

    .project-thumbnail{
        background-color: #f1f1f1;
        text-align: center;
        max-width:100%;
        //max-height:70%;
        margin: 32px 0 0 0;
        width: 100%;
        //height: 70%;
    }

}

.project-action-content-menu{
    padding: 0 !important;
    min-width: 180px !important;
}

#project-action-menu{
    .v-list-item{
        height: 38px !important;
        cursor: pointer;
        &:hover{
            background-color: #e7e7e7;
        }
        .v-list-item__content{
            padding: 6px 0;
            p{
                margin: 0;
                span{
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 9px;
                }
            }
        }
    }
}

.no-project{
    box-shadow: 0 0 0 0 rgba(61, 166, 232, 0.7);
    -webkit-animation: pulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);
    -moz-animation: pulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);
    -ms-animation: pulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);
    animation: pulse 1.5s infinite cubic-bezier(0.66, 0, 0, 1);
}

@-webkit-keyframes pulse {to {box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);}}
@-moz-keyframes pulse {to {box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);}}
@-ms-keyframes pulse {to {box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);}}
@keyframes pulse {to {box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);}}

</style>
